<div class="task-card">
  <div class="header">
    <span class="license-plate">{{ task.vehicle.registrationNumber }}</span>
    <span class="car-model">{{ task.vehicle.make }} {{ task.vehicle.model }}</span>
  </div>

  <div class="task-info">
    <div>
      <span *ngIf="isCustomerView && task.supplierId">
        Supplier:
        <span class="organisation-name-link">
          <a href="/app/supplier-information/{{ task.supplierId }}">
            {{ task.supplierName }}
          </a>
        </span>
        <span style="padding: 5px">/</span>
      </span>

      <span *ngIf="!isCustomerView && task.customerId">
        Customer:
        <span class="organisation-name-link">
          <a href="/app/customer-information/{{ task.customerId }}">
            {{ task.customerName }}
          </a>
        </span>
        <span style="padding: 5px">/</span>
      </span>

      <span class="distance"
        >{{ task.distanceInMiles | number : '1.1-1' }} miles
        <span class="detail-est">EST.</span>
      </span>
      <span style="padding: 5px">/</span>
      <span class="duration"
        >{{ task.estimateTimeString }}
        <span class="detail-est">EST.</span>
      </span>
    </div>

    <span class="task-type">{{ task.taskTypeName }}</span>
    <span class="task-status">{{ task.statusText }}</span>
  </div>

  <div class="locations">
    <ng-container
      *ngTemplateOutlet="
        locationT;
        context: {
          $implicit: {
            title: 'PICK-UP',
            postcode: task.pickupLocation.postcode,
            earliest: task.pickupEarliestDateTime,
            latest: task.pickupLatestDateTime,
            name: task.pickupForename + ' ' + task.pickupSurname,
            tel1: task.pickupPhone1,
            tel2: task.pickupPhone2,
            email: task.pickupEmail
          }
        }
      "
    ></ng-container>

    <div class="arrow"><img src="/assets/images/telephony/green-arrow.svg" /></div>

    <ng-container
      *ngTemplateOutlet="
        locationT;
        context: {
          $implicit: {
            title: 'DROP-OFF',
            postcode: task.dropoffLocation.postcode,
            earliest: task.dropoffEarliestDateTime,
            latest: task.dropoffLatestDateTime,
            name: task.dropoffForename + ' ' + task.dropoffSurname,
            tel1: task.dropoffPhone1,
            tel2: task.dropoffPhone2,
            email: task.dropoffEmail
          }
        }
      "
    ></ng-container>
  </div>

  <div
    class="notes"
    (click)="$event.stopPropagation(); task.showNotes = !task.showNotes"
    *ngIf="task.notes && task.notes.length > 0"
  >
    <div style="width: 55px; font-weight: 500">{{ task.notes.length }} Notes</div>
    <div *ngIf="task.showNotes" style="margin-left: 20px; font-size: 13px">
      <div *ngFor="let note of task.notes">
        <span style="font-weight: bold">{{ note.created | date : 'EEE dd MMM HH:mm' }}</span
        >&nbsp;<i class="fa fa-sticky-note-o"></i> {{ note.description }}
      </div>
    </div>
    <div>
      <i *ngIf="!task.showNotes" class="fa fa-chevron-down icon"></i>
      <i *ngIf="task.showNotes" class="fa fa-chevron-up icon"></i>
    </div>
  </div>
</div>

<ng-template #locationT let-data>
  <div class="col-del">
    <div class="header">{{ data.title }}</div>
    <div class="location-line-bold">
      <i class="fa fa-map-marker location-icon"></i> {{ data.postcode }}
    </div>
    <div class="location-line-bold">
      <i class="fa fa-calendar location-icon"></i>
      {{ data.earliest | date : "EEE dd MMM 'yy HH:mm" }} -
      {{ data.latest | date : "EEE dd MMM 'yy HH:mm" }}
    </div>
    <div class="location-line" *ngIf="data.name?.trim()?.length > 0">
      <i class="fa fa-user location-icon"></i> {{ data.name }}
      <span class="location-line-blue" style="margin-left: 5px">
        <span *ngIf="data.tel1" style="margin-right: 10px">
          <i class="fa fa-phone location-icon"></i>{{ data.tel1 }}
        </span>
        <span *ngIf="data.tel2"> <i class="fa fa-phone location-icon"></i>{{ data.tel2 }} </span>
      </span>
    </div>

    <div class="location-line-blue" *ngIf="data.email">
      <i class="fa fa-envelope location-icon"></i> {{ data.email }}
    </div>
  </div>
</ng-template>
